"use client";

import { cn } from "../utils/mergeClassNames";
import { Spinner } from "./spinner";

interface LoadingOverlayProps {
  isLoading: boolean;
  className?: string;
}

/**
 * Full-viewport loading overlay with 70% transparent background and centered spinner.
 * Reusable across product grid, blog, search, and other pages.
 */
function LoadingOverlay({ isLoading, className }: LoadingOverlayProps) {
  if (!isLoading) return null;

  return (
    <div
      role="status"
      aria-label="Loading"
      className={cn("fixed inset-0 z-50 flex items-center justify-center bg-black/30", className)}
    >
      <Spinner className="size-10 text-foreground" />
    </div>
  );
}

export { LoadingOverlay };
